import { render } from "./AppBreadcrumb.vue?vue&type=template&id=8ee008b4&ts=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=ts"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=8ee008b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__